<template>
  <div>
    <h1>cursus keuze</h1>
    <input v-model="cursuskeuze" type="radio" id="elearning" name="elearning" value="elearning" />
    <label for="elearning">elearning</label>
    <br />
    <input v-model="cursuskeuze" type="radio" id="klassikaal" name="klassikaal" value="klassikaal" />
    <label for="klassikaal">klassikaal</label>
    <br />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  components: {},
  created() {
    // this.changeRoute(route);
  },
  watch: {},
  computed: {
    cursuskeuze: {
      get() {
        return this.$store.state.wizard.cursuskeuze
      },
      set(value) {
        this.SetCursusKeuze(value)
      }
    }
  },
  methods: {
    ...mapMutations('wizard', ['SetCursusKeuze'])
  }
}
</script>
